<template>
    <div class="service-list">
        <div class="service-list--loader" v-if="!isReady || isLoading">
            <spinning-loader/>
        </div>
        <p class="service-list--api-error" v-else-if="apiError">
            {{ apiError.message }}
        </p>
        <div v-else-if="!listItems.length">
            <div class="service-list--intro service-list--row grid--row">
                <div class="service-list--col grid--col">
                    <div>
                        <h2 class="service-list--main-title u-reset">
                            {{ noResultsFoundTitle }}
                        </h2>
                        <!-- eslint-disable vue/no-v-html -->
                        <p class="service-list--description u-reset" v-html="noResultsFoundDescription"/>
                        <!-- eslint-enable vue/no-v-html -->
                    </div>
                    <conditional-link class="btn btn__primary btn__medium u-reset"
                            :label="noResultsFoundLinkLabel"
                            :path="noResultsFoundLinkUrl"/>
                </div>
            </div>
        </div>
        <template v-else>
            <div class="service-list--intro service-list--row grid--row">
                <div class="service-list--col grid--col">
                    <h2 class="service-list--main-title u-reset" v-if="isInitial">
                        {{ mainTitle }}
                    </h2>
                    <template v-else-if="tag">
                        <div>
                            <h2 class="service-list--main-title u-reset">
                                {{ tag.title }}
                            </h2>
                            <p class="service-list--description u-reset" v-if="tag.description">
                                {{ tag.description }}
                            </p>
                        </div>
                        <conditional-link class="btn btn__secondary btn__medium u-reset"
                                :external="tag.link.external"
                                :label="tag.link.text"
                                :path="tag.link.url"
                                v-if="tag.link"/>
                    </template>
                </div>
            </div>
            <div class="service-list--row grid--row">
                <div class="service-list--col grid--col">
                    <ul class="service-list--list u-reset">
                        <li class="service-list--item"
                                v-for="product in listItems"
                                :id="'service-' + product.id"
                                :key="product.id">
                            <dyn-service-list-product :has-arrow="true" v-bind="product"/>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="service-list--bottom-lists service-list--row grid--row" v-if="isInitial">
                <div class="service-list--skills service-list--col grid--col">
                    <h3 class="service-list--skills-title u-reset">
                        {{ skillsTitle }}
                    </h3>
                    <ul class="service-list--list u-reset">
                        <li class="service-list--item"
                                v-for="skill in skills"
                                :key="skill.id">
                            <dyn-service-list-product v-bind="skill" :tags="[]"/>
                        </li>
                    </ul>
                </div>
                <div class="service-list--topics service-list--col grid--col">
                    <h3 class="service-list--topics-title u-reset">
                        {{ topicsTitle }}
                    </h3>
                    <ul class="service-list--list u-reset">
                        <li class="service-list--item"
                                v-for="topic in topics"
                                :key="topic.id">
                            <dyn-service-list-product v-bind="topic" :tags="[]"/>
                        </li>
                    </ul>
                </div>
            </div>
            <pagination
                    :current="pagination.current_page"
                    :total="pagination.total_pages"
                    :max-amount="4"
                    v-if="isPaginationVisible"
                    @page-change="onPageChange"/>
        </template>
    </div>
</template>

<script>
    import SpinningLoader from '../../components/loaders/spinning-loader/spinning-loader';
    import { mapState, mapActions } from 'vuex';
    import ConditionalLink from '../../components/conditional-link/conditional-link';
    import Pagination from '../../components/pagination/pagination';

    export default {
        components: { Pagination, ConditionalLink, SpinningLoader },
        props: {
            noResultsFoundTitle: {
                type: String,
                required: true,
            },
            noResultsFoundDescription: {
                type: String,
                required: true,
            },
            noResultsFoundLinkLabel: {
                type: String,
                required: true,
            },
            noResultsFoundLinkUrl: {
                type: String,
                required: true,
            },
            mainTitle: {
                type: String,
                required: true,
            },
            skillsTitle: {
                type: String,
                required: true,
            },
            topicsTitle: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                isReady: false,
            };
        },
        computed: {
            ...mapState('services', ['isLoading', 'listItems', 'tag', 'isInitial', 'pagination', 'skills', 'topics', 'apiError']),

            isPaginationVisible() {
                return this.pagination && !this.isInitial && this.pagination.total_pages > 1;
            },
        },
        methods: {
            ...mapActions('services', ['fetchServices', 'setCurrentPage', 'activeFilters']),
            fetchServicesWithUrlGetParams(additionalParams) {
                const params = new URLSearchParams(window.location.search);

                if (additionalParams) {
                    Object.entries(additionalParams).forEach(([key, value]) => {
                        params.set(key, value);
                    });
                }

                return this.fetchServices({
                    params,
                });
            },
            scrollToTop() {
                window.scrollTo({
                    top: 0,
                    left: 0,
                });
            },
            onPageChange(event, page) {
                this.fetchServicesWithUrlGetParams({ page }).then(this.scrollToTop);
            },
        },
        mounted() {
            this.fetchServicesWithUrlGetParams().then(() => {
                this.isReady = true;
            });
        },
    };
</script>
